import React, { useEffect, useState } from 'react';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';

import { CustomButton, HumbeeTabs } from '../../../v2/MUI_custom_component';
import { BillingInfo } from '../../Components';
import ProductCard from '../../Inventory/components/ProductCard';
import { decodeToken, deliveryTypeDropDown } from '../../../utils/settings';
import { createDispatchPlanAction } from './API/Action';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

const Checkout = () => {
  const isMobile = useMediaQuery('(max-width:1200px)');
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedSupplier: selectedManufacturer, selectedEntity: selectedCompanyEntity, selectedSupplierData: selectedSupplierData, selectedEntityInfo } = useSelector(
      (state) => state.entityReducer
  );
  const cash_config_discount = selectedEntityInfo && selectedEntityInfo?.cash_discount_config;
  const checkoutData = location.state?.checkOutData || {};
  const {
    ship_to_parties_info = [],
    order_summary_info = {}
  } = checkoutData;

  const [currentTab, setCurrentTab] = useState(0);
  const[loading, setLoading] = useState(false)

  const getDeliveryTypeLabel = (value) => {
    const type = deliveryTypeDropDown.find(t => t.value === value);
    return type ? type.label : '-';
  };
  const { order_booking_id } = useSelector((state) => {
    return {
      order_booking_id: state.dpReducer?.order_booking_id,
      };
  });
  const token = localStorage.getItem('token');
  const [tokenData, setTokenData] = useState(null);
  useEffect(() => {
      const getTokenData = async () => {
        if (token) {
          try {
            const decoded = await decodeToken(token);
            setTokenData(decoded);
          } catch (err) {
            console.error('Failed to decode token', err);
          }
        }
      };
      getTokenData();
    }, [token]);
  const handleConfirmAndProceed = async() => {
    const payload = {
      supplier_id: selectedManufacturer,
      buyer_id: tokenData.default_company_info.company_id,
      buyer_esi_id: selectedCompanyEntity,
      seller_id: selectedManufacturer,
      order_booking_id: order_booking_id,
      cash_discount_config: cash_config_discount,
      order_products_delivery: checkoutData.ship_to_parties_info.map(
        (shipToParty) => {
          const stpInfo = shipToParty.ship_to_party_info;
          return {
            ship_to_party_info: {
              operation_type: 1,
              deliver_to: stpInfo.deliver_to,
              deliver_to_esi_id: stpInfo.deliver_to_esi_id,
              company_name: stpInfo.company_name,
              delivery_address: {
                address_line_1: stpInfo.delivery_address.address_line_1,
                address_line_2: stpInfo.delivery_address.address_line_2,
                address_line_3: stpInfo.delivery_address.address_line_3,
              },
              order_product_delivery_type: stpInfo.delivery_type,
              order_delivery_contact_no: stpInfo.company_phone_no,
              order_delivery_contact_person_name:
              stpInfo.order_delivery_contact_person_name || '',
              requested_district_id: stpInfo.delivery_district_id,
              requested_pincode: stpInfo.delivery_pincode,
              incoterms: 2,
              location_id: stpInfo.location_id,
              pricing_geography_id: stpInfo.pricing_geography_id
            },
            products_info:
              shipToParty.products_summary_info.map((product) => ({
                operation_type: 1,
                product_id: product.product_id,
                quantity: {
                  quantity_in_bags: product.quantity.quantity_in_bags,
                  quantity_in_metric_ton: product.quantity.quantity_in_metric_ton,
                  multiplier: product.quantity.multiplier,
                  unit: product.quantity.unit,
                  base_unit: product.quantity.base_unit,
                },
              })
            ),
          };
        }
      ),
    };
    setLoading(true)
    const { data, error, message } = await createDispatchPlanAction(payload);
    setLoading(false)
    if(!error){
      navigate('/complete-dp',{ state: {
        orderId : data.order_id 
      }})
    }else{
      toast.error(message)
    }
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex', 
          justifyContent:'end', 
          p: { xs: 2, md: 0 },
          mr: { xs: 0, md: 4 },
          position: {xs: 'fixed', md: 'relative'}, 
          top: { xs: '88px', md: 0 }, 
          left: {xs: 0, md: 'auto'},
          right: {xs: 0, md: 'auto'},
          zIndex: {xs: 1000, md: 'auto'}, 
          zIndex: 1000, 
          boxShadow: {xs: '0px 2px 8px 0px #0000001A', md: 'none'},
          background: {xs: '#FAFAFA', md: 'transparent'},
          pb: 0,  
        }}
      >
        <CustomButton
          variant="filled"
          color="primary"
          label="Checkout"
          onClick={handleConfirmAndProceed}
          loading={loading}
          sx={{ width: { xs: '100%', sm: 'auto' } }}
        />
      </Box>

      <Box sx={{ mt: { xs: '72px', md: 0 }, p: { xs: 2, md: 4 }, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography variant="h2">Checkout</Typography>
        <Box sx={{ background: '#fff', borderRadius: 2, p: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="labelD">Billing Details</Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: {xs: 0.5, md: 1} }}>
            {order_summary_info.total_bill_info?.map((item, index) => (
              <Box
                key={index}
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  borderTop:
                    item.type === 'net_amount' ? '1px solid #D9D9D9' : 'none',
                  pt: item.type === 'net_amount' ? 1 : 0
                }}
              >
                <Typography variant="labelM">
                  {item.display_name}
                </Typography>
                <Typography
                  variant="p3"
                  sx={{ fontWeight: item.type === 'net_amount' ? 600 : 400 }}
                >
                  {item.label}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        <HumbeeTabs
          data={ship_to_parties_info}
          currentTab={currentTab}
          onChange={(e, newValue) => setCurrentTab(newValue)}
          getTabLabel={(item, index) => `Ship to Party ${index + 1}`}
          getTabKey={(item, index) => index}
          tabVariant={isMobile ? 'small' : 'default'}
          renderTabContent={(shipToParty) => {
            const {
              ship_to_party_info,
              products_summary_info = []
            } = shipToParty;
            const delivery = ship_to_party_info.delivery_address || {};
  
            return (
              <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2}}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                     <Box sx={{ background: '#fff', p: 2, borderRadius: 2,  display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <BillingInfo
                          buyer={{
                            company_name: ship_to_party_info.company_name,
                            company_phone_no: ship_to_party_info.company_phone_no,
                            company_registered_address: ship_to_party_info.company_registered_address,
                            erp_code: ship_to_party_info.company_erp_code,
                          }}
                          title="Ship to Party"
                          showRoleChip
                          orderSummary
                    />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box
                      sx={{
                        p: 2,
                        background: '#fff',
                        borderRadius: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 1
                      }}
                    >
                      <Typography variant="labelD">Shipping Address</Typography>
                       <Box sx={{ display: 'flex', gap: 1}}>
                        <Typography variant="labelM" sx={{ minWidth: '150px', color: '#666' }}>
                          Address
                        </Typography> 
                        <Typography variant="p3">
                          {delivery.address_line_1}, {delivery.address_line_2} 
                          {delivery.address_line_3}, {ship_to_party_info.location_name}, {ship_to_party_info.requested_district_name}, {ship_to_party_info.pincode}
                        </Typography> 
                      </Box>

                      <Typography variant="labelD" sx={{ mt: 2 }}>
                        Logistic Details
                      </Typography>
                      
                      <Box sx={{ display: 'flex', gap: 1}}>
                        <Typography variant="labelM" sx={{ minWidth: '150px', color: '#666' }}>
                          Delivery Type
                        </Typography> 
                        <Typography variant="p3">
                          {ship_to_party_info.order_delivery_contact_no ||
                        getDeliveryTypeLabel(ship_to_party_info.delivery_type)|| '-'}
                        </Typography> 
                      </Box>
                      <Box sx={{ display: 'flex', gap: 1}}>
                        <Typography variant="labelM" sx={{ minWidth: '150px', color: '#666' }}>
                          Receiver’s Name
                        </Typography> 
                        <Typography variant="p3">
                          {ship_to_party_info.order_delivery_contact_person_name || '-'}
                        </Typography> 
                      </Box>
                      <Box sx={{ display: 'flex', gap: 1}}>
                        <Typography variant="labelM" sx={{ minWidth: '150px', color: '#666' }}>
                          Receiver’s Mobile number
                        </Typography> 
                        <Typography variant="p3">
                          {ship_to_party_info.order_delivery_contact_no || '-'}
                        </Typography> 
                      </Box>
                    </Box>
                  </Grid>
                </Grid>

                {/* ---------- TOTAL QUANTITY ---------- */}
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="labelD">Total Quantity</Typography>
                  <Typography variant="labelD">
                    {products_summary_info.reduce(
                      (sum, p) => sum + p.quantity.quantity_in_metric_ton,
                      0
                    )}{' '}
                    Ton
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                  {products_summary_info.map(product => (
                    <ProductCard
                      key={product.product_id}
                      productName={product.product_name}
                      imageUrl={product.product_logo}
                      quantity={product.quantity.quantity_in_metric_ton}
                      price={product.price_info?.landing_price}
                      showQuantityControls={false}
                      showDeleteButton={false}
                    />
                  ))}
                </Box>
              </Box>
            );
          }}
        />
      </Box>
    </>
  );
};

export default Checkout;
